import { render, staticRenderFns } from "./InterestedIn.vue?vue&type=template&id=506751b1&scoped=true&"
import script from "./InterestedIn.vue?vue&type=script&lang=js&"
export * from "./InterestedIn.vue?vue&type=script&lang=js&"
import style0 from "./InterestedIn.vue?vue&type=style&index=0&id=506751b1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "506751b1",
  null
  
)

export default component.exports